import React from 'react';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose, contains, is } from 'ramda';
import connect from 'react-redux/es/connect/connect';
import { Map, List } from 'immutable';
import styleFile from './header.js';

import { StepCursor } from '../StepCursor';
import { RichText, Icon, Button } from '@synergycms_core/components/generic';
import {
  getReservationTotals,
  getReservationTotalsBothModes,
  parseTaxes,
  parseTaxesPreview,
  applyMandatoryFeeSplit,
  sumTaxAmounts,
  getDisplayedTotalPrice,
  round
} from '../../../utils';
import { validateAsyncComponent } from '../../HoC';
import { AvailMainSideSummary } from '../AvailMainSideSummary';
import Modal from '@synergycms_core/components/generic/Modal';
import Price from '@synergycms_core/components/generic/Price';
import actions from '../../../store/actions';
import classnames from 'classnames/bind';
import SearchOptions from '../SearchOptions';
import AvailEngine from '../AvailEngine';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

import { contextualizeAppConfig } from "@synergycms_core/store/app/utils";
import { withContent } from '@synergycms_core/components/providers/translateProvider';
// Header component modules
import HeaderLogo from './HeaderLogo';
import ReservationInfo from './ReservationInfo';
import MobilePreheader from './MobilePreheader';
import LoginModule from './LoginModule';
import LangSelector from './LangSelector';
import SearchButton from './SearchButton';
import RoomInfo from './RoomInfo';
import PromoCode from './PromoCode';
import PhoneSelector from './PhoneSelector';

class Header extends React.Component {
  static displayName = 'Header';

  constructor(props) {
    super(props);
    this.state = {
      visibleEngine: this.props.config.engineIsVisible
    };
    this.cx = classnames.bind(styleFile);
  }

  componentWillUnmount() {
    this.dummyRef = null;
    this.headerRef = null;
    document.removeEventListener('scroll', this.setFixedHeader);
  }

  componentDidMount() {
    this.setFixedHeader();
  }

  componentDidUpdate(prevProps) {
    // GLOSARIO.md FCL-006 - con el motor fijo, quien pida "abrir el motor" (p.ej. AvailAlert) solo necesita
    // llevar al usuario hasta el; se resetea el flag para que no se quede a true en el store
    if (this.props.config.engineIsVisible && !prevProps.config.engineIsVisible && this.isEngineFixed()) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.props.config.showEngine(false);
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.config.engineIsVisible !== prevState.visibleEngine) {
      return { visibleEngine: nextProps.config.engineIsVisible };
    } else return null;
  }

  isModalBreak = ()=>{
    return window.innerWidth < this.props.theme.themeValues.modalBreak;
  }



  showAvailDatePicker = () => {
    this.props.config.showEngine(!this.state.visibleEngine);
    this.setState(
      (state) => {
        return {
          visibleEngine: !state.visibleEngine
        };
      },
      () => {
        if (this.dummyRef && this.headerRef) {
          this.dummyRef.style.height = this.headerRef.offsetHeight + 'px';
        }
      }
    );
  };

  setFixedHeader = () => {
    if (this.headerRef && this.dummyRef) {
      const headerRef = this.headerRef;

      const dummyRef = this.dummyRef;
      if (dummyRef.getBoundingClientRect().top < 0) {
        headerRef.style.position = 'fixed';
        headerRef.style.top = 0;
      } else {
        headerRef.style.top = null;
        headerRef.style.position = 'static';
      }
      //if (dummyRef.offsetHeight === 0) {
      dummyRef.style.height = headerRef.offsetHeight + 'px';
      //}
    }
  };

  hasHeaderConfig = (configName) => {
    const { stepCode, appConfig } = this.props.config;

    const headerConfig = Map(appConfig.get('avail_header', Map()));
    const configValue = headerConfig.get(configName, '');

    return !configValue ? false : configValue.split(';').includes(stepCode);
  }

  isEngineFixed = () => {
    const engineAlwaysVisible = this.props.config.appConfig.getIn(['avail_header', 'engine_always_visible'], false);
    return !this.isModalBreak() && engineAlwaysVisible && this.hasHeaderConfig('engine_box');
  }

  // Dynamic header viene a ser desde el logo hasta el boton de buscar
  getDynamicHeaderDesktop = () => {

    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const {
      params,
      currentStep,
      hotel,
      country,
      city,
      stayLength,
      enableAge,
      appConfig,
      stepCode,
      langInfo
    } = config;
    const showLogo = this.hasHeaderConfig('show_logo');
    const availInfoTheme = appConfig.getIn(['avail_header','avail_info_theme'], "complete");
    const availMinimalTheme = availInfoTheme === 'minimal';
    const dateFormat = appConfig.get('show_date_format', "minified");

    const cx = this.props.theme.bind();
    const istCustomerForm = stepCode === 'customerForm';
    const itsMultiHotelAvail = currentStep.get('code') === 'multiHotelAvail';
    const notNewHeaderAvail = !availMinimalTheme && !istCustomerForm;

    if (this.isEngineFixed()) {
      return (
        <>
          {showLogo && <HeaderLogo langCode={langInfo.get('code')}/>}
          <div className={classes.fixedEngineContainer}>
            <AvailEngine hideCloseButton={true} />
          </div>
        </>
      );
    }

    if(this.hasHeaderConfig('engine_box')) {
      return (
        <>
          {showLogo && <HeaderLogo langCode={langInfo.get('code')}/>}
          <div className={[classes.leftContainer, cx({ newHeaderAvail : availMinimalTheme, oldHeaderAvail: notNewHeaderAvail, multiAvailHeader :itsMultiHotelAvail})].join(' ')} onClick={this.showAvailDatePicker}>
            <ReservationInfo
              hotel={hotel}
              params={params}
              currentStep={currentStep}
              country={country}
              city={city}
              stayLength={stayLength}
              availInfoTheme={availInfoTheme}
              dateFormat={dateFormat}
              modalBreak={this.isModalBreak()}/>
            <RoomInfo enableAge={enableAge} availInfoTheme={availInfoTheme} params={params} modalBreak={this.isModalBreak()}/>
            {availMinimalTheme && <PromoCode />}
            <SearchButton availInfoTheme={availInfoTheme}/>
          </div>
        </>
      );
    } else if (showLogo) {
      return <HeaderLogo langCode={langInfo.get('code')}/>;
    } else {
      return <></>;
    }
  }

  getDynamicHeaderMobile = () => {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const {
      params,
      currentStep,
      hotel,
      country,
      city,
      reservationTotals,
      giftCodeDiscount,
      displayedTotalPrice,
      summaryPriceBreakdown,
      stayLength,
      appConfig,
      langInfo,
      stepCode,
      countryCode
    } = config;

    const availInfoTheme = appConfig.getIn(['avail_header','avail_info_theme'], "complete");
    const availMinimalTheme = availInfoTheme === 'minimal';
    const dateFormat = appConfig.get('show_date_format', "minified");

    const langActive = langInfo.get('code');

    const cx = this.props.theme.bind();

    const itsMultiHotelAvail = currentStep.get('code') === 'multiHotelAvail';
    const istCustomerForm = stepCode === 'customerForm';

    const notNewHeaderAvail = !availMinimalTheme && !itsMultiHotelAvail && !istCustomerForm;
    if (contains(currentStep.get('code'), ['multiHotelAvail', 'monoHotelAvail', 'noAvail'])) {
      return (
        <>
          {availMinimalTheme && (
            <MobilePreheader
              hasHeaderConfig={this.hasHeaderConfig}
              langActive={langActive}
              countryCode={countryCode}
            />
          )}
          <Button onClick={this.showAvailDatePicker} innerStyle={classes.datePickerButton} ariaLabel={"_%destino%_"} translate={true}>
            <div className={[classes.tableContainer, cx({
              miniTableContainer: availMinimalTheme,
              mobileTableContainer: availMinimalTheme,
              notAvailMonoMinimal: !istCustomerForm && !availMinimalTheme
            })].join(' ')}>
              <ReservationInfo
                hotel={hotel}
                params={params}
                currentStep={currentStep}
                country={country}
                city={city}
                stayLength={stayLength}
                availInfoTheme={availInfoTheme}
                dateFormat={dateFormat}
                modalBreak={this.isModalBreak()} />
              {!availMinimalTheme ?
              <RoomInfo params={params} onClick={this.showAvailDatePicker} availInfoTheme={availInfoTheme} modalBreak={this.isModalBreak()}/> :
              <div className={classes.mobileRoomInfo}>
                <div className={classes.modifySearch}>
                  <RichText text={'_%editar%_'} translate={true} innerStyle={['roboto14Black',classes.modifyTitle]} ucFirst={true}/>
                </div>
                <RoomInfo params={params} onClick={this.showAvailDatePicker} availInfoTheme={availInfoTheme} modalBreak={this.isModalBreak()}/>
              </div>
              }
              {!availMinimalTheme && (
                <div className={[classes.modifySearch].join(' ')}>
                  <Icon content={''} innerStyle={['size17', classes.pencilIcon]} />
                </div>
              )}
            </div>
          </Button>
        </>
      );
    }

    return (
      <>
        {availMinimalTheme && (
          <MobilePreheader
            hasHeaderConfig={this.hasHeaderConfig}
            langActive={langActive}
          />
        )}

        {currentStep.get('code') !== 'confirmation' && (
          <div className={[[classes.leftContainer, cx({oldCtnHeaderAvail : !availMinimalTheme})].join(' ')]}>
            <div className={[classes.tableContainer, cx({
                miniTableContainer: availMinimalTheme
              })].join(' ')}>
              <Button
                onClick={this.showAvailDatePicker}
                innerStyle={[[classes.leftButton, cx({oldHeaderMobileAvail: notNewHeaderAvail && !istCustomerForm, newZoneHeader : !istCustomerForm})].join(' ')]}
                ariaLabel={"_%destino%_"}
                translate={true}>
                <ReservationInfo
                  hotel={hotel}
                  params={params}
                  currentStep={currentStep}
                  country={country}
                  city={city}
                  stayLength={stayLength}
                  availInfoTheme={availInfoTheme}
                  dateFormat={dateFormat}
                  modalBreak={this.isModalBreak()} />
              </Button>
            </div>
            <Modal
              innerStyle={['resumeModalStyle']}
              //contentStyle={classes.testing}
              closeButtonStyle={classes.summaryCloseButton}
              modalStyle={classes.resumeModalStyle}
              defaultStyle={false}
              popover={<AvailMainSideSummary innerStyle={'summaryModal'} />}
              typeModal={'AvailMainSideSummaryTooltip'}>
              <div className={[classes.tableContainer, classes.priceMoreDetails, cx({
                miniTableContainer: availMinimalTheme
              })].join(' ')}>
                <Button ariaLabel={"_%resumen de reserva%_"} translate={true}>
                  <div className={classes.floatedContainer}>
                    <div>
                      {reservationTotals && (!summaryPriceBreakdown || displayedTotalPrice !== null) && (
                        <Price innerStyle={classes.resumePrice} amount={displayedTotalPrice !== null ? displayedTotalPrice : reservationTotals.get('total_price') + giftCodeDiscount} />
                      )}
                    </div>
                    <div className={classes.arrowContainer}>
                    <RichText
                        innerStyle={classes.headerTitle}
                        translate={true}
                        ucFirst={true}
                        plural={true}
                        text={'_%ver detalles%_'}
                        rightIcon={{
                          unicodeContent: langActive === 'AR' ? '005C' : 'e052',
                          innerStyle: ['size12', 'marginLeft5', 'mainColor']
                        }}
                      />
                    </div>
                  </div>
                </Button>
              </div>
            </Modal>
          </div>
        )}
      </>
    );
  }

  // Los modulos adicionales son los que se muestran a la derecha del header
  getAdditionalModules = () => {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const {
      appConfig,
      langInfo,
      countryCode
    } = config;

    const availInfoTheme = appConfig.getIn(['avail_header','avail_info_theme'], "complete");
    const availMinimalTheme = availInfoTheme === 'minimal';
    const langActive = langInfo.get('code');
  
    return (
      <>
        {this.hasHeaderConfig('step_cursor') && (
          <div className={classes.stepContent}>
            <StepCursor />
          </div>
        )}
        {availMinimalTheme && (
          <div className={classes.userConfigsContainer}>
            {this.hasHeaderConfig('login_module') && <LoginModule/>}
            {this.hasHeaderConfig('show_phone') && this.phoneSelectorWrapper()}
            {this.hasHeaderConfig('lang_selector') && <LangSelector langActive={langActive} countryCode={countryCode}/>}
          </div>
        )}
      </>
    )

  }

  phoneSelectorWrapper = () => {

      return <PhoneSelector />;

  }

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const {
      currentStep,
      stepCode,
      appConfig,
    } = config;

    const isMultiHotelAvail = currentStep.get('code') === 'multiHotelAvail';
    const availInfoTheme = appConfig.getIn(['avail_header','avail_info_theme'], "complete");
    const availMinimalTheme = availInfoTheme === 'minimal';
    const cx = this.props.theme.bind();

    if (contains(stepCode, ['cancelation', 'newCof'])) {
      return null;
    }

    // GLOSARIO.md FCL-006 - con el motor fijo se ignora customer.header.engine
    const engineFixed = this.isEngineFixed();
    const showOnlyEngine = this.state.visibleEngine && !engineFixed;

    /**
    *
    * Estructura del header en version desktop:
    *
    * XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    * X                                         X                          X
    * X     [DynamicHeader]                     X     [AdditionalModules]  X
    * X logo roomInfo reservInfo searchButton   X  steps login phone lang  X
    * X                                         X                          X
    * XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    *
    *  Estructura del header en version mobile, aqui los modulos adicionales van en el preheader
    *  y [AdditionalModules] desaparece, lo cual todo el render recae en el [DynamicHeader] de mobile:
    *
    *      [DynamicHeader]
    *  XXXXXXXXXXXXXXXXXXXXXXXXX
    *  X   MobilePreheader     X
    *  X logo login phone lang X
    *  X                       X
    *  XXXXXXXXXXXXXXXXXXXXXXXXX
    *  X                       X
    *  X reservationInfo       X
    *  X roomInfo              X
    *  X                       X
    *  XXXXXXXXXXXXXXXXXXXXXXXXX
    *
    */
    const DynamicHeader = !this.isModalBreak() ? this.getDynamicHeaderDesktop()  : this.getDynamicHeaderMobile();
    const AdditionalModules = !this.isModalBreak() ? this.getAdditionalModules() : null;

    return (
      <React.Fragment>
        <div
          className={this.state.visibleEngine || engineFixed ? classes.opennedEngine : classes.closedEngine}
          ref={(dummyRef) => {
            if (dummyRef) {
              this.dummyRef = dummyRef;
              this.setFixedHeader();
            }
          }}>
          <header
            className={cx(classes.wrapperHeader, {
              mapFilters: config.searchOptionsIsVisible && theme.width < 1300
            })}
            ref={(headerRef) => {
              if (headerRef) {
                this.headerRef = headerRef;
                document.removeEventListener('scroll', this.setFixedHeader);
                document.addEventListener('scroll', this.setFixedHeader);
                this.setFixedHeader();
              }
            }}>
            <div className={
              [
                classes.header,
                theme.computedInnerStyle,
                cx({
                  minimalHeader: availMinimalTheme,
                  hasEngine: this.hasHeaderConfig('engine_box')
                })
              ].join(' ')}
            >
              <div className={isMultiHotelAvail ? classes.multiHotelHeader : classes.headerContainer}>
                <div className={cx(classes.infoContainer, { fixedEngine: engineFixed })}>

                  {!showOnlyEngine && (
                    <>
                      {DynamicHeader}
                      {AdditionalModules}
                    </>
                  )}

                  {showOnlyEngine && (
                    <AvailEngine />
                  )}

                </div>
              </div>
              {config.searchOptionsIsVisible && theme.width < 1300 && (
                <SearchOptions innerStyle={['multiHotelSearchOptions', 'mapOptions']} />
              )}
            </div>
          </header>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (store) => {
  const hotelId = store.getIn(['customer', 'current_hotel'], null);

  const params = store.getIn(['customer', 'params', 'params'], undefined);
  const urlParams = store.getIn(['customer', 'params', 'url_params'], undefined);

  const country =
    params &&
    params.get('country_id') &&
    store.getIn(['hotels', 'hotels_info', 'countries'], List()).find((country) => {
      return country.get('id') === parseInt(params.get('country_id'), 10);
    });

  const city =
    params &&
    params.get('city_id') &&
    store.getIn(['hotels', 'hotels_info', 'cities'], List()).find((city) => {
      return city.get('id') === parseInt(params.get('city_id'), 10);
    });

  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks'], null);

  const amountPromoPaid = store.getIn(['customer', 'reservation', 'payment', 'amount_promo_paid'], 0);
  let giftCodeDiscount = 0;
  if (amountPromoPaid > 0) {
    giftCodeDiscount = amountPromoPaid * -1;
  }
  let childsInfo = store.getIn(['hotels', hotelId, 'occups_free'], null);
  const enableAge =
    !!childsInfo &&
    Number.isFinite(childsInfo.getIn(['baby', 'start'])) &&
    Number.isFinite(childsInfo.getIn(['child', 'end']));

  const hotel = (!hotelId && Map()) || store.getIn(['hotels', hotelId], Map());
  const appConfig = contextualizeAppConfig(store, hotelId);
  const stepCode = store.getIn(['customer', 'step', 'current_step', 'code']);

  // GLOSARIO.md FCL-003 - el "importe total" del header mobile debe coincidir con el que se
  // muestra en AvailMainSideSummary/CustomerForm (subtotal sin impuestos + fee obligatoria + resto
  // de impuestos no incluidos), en vez de solo reservationTotals.total_price.
  // La fuente de impuestos se elige por disponibilidad de datos, no por stepCode: al pasar de
  // serviceHotelAvail a customerForm, el step ya cambia de forma sincrona pero customer.reservation
  // se vacia y se repuebla de forma asincrona (reservation.postAsync), asi que durante esa ventana
  // hay que seguir usando parseTaxesPreview aunque el stepCode ya sea 'customerForm'.
  const summaryPriceBreakdown = hotel.get('summary_price_breakdown', false);
  const reservationObj = store.getIn(['customer', 'reservation'], Map());
  let displayedTotalPrice = null;
  if (summaryPriceBreakdown) {
    const summaryBreakdownMode = appConfig.get('summary_taxes_breakdown', 'default');
    let parsedTaxes = null;

    if (reservationObj.get('blocks', List()).size > 0) {
      parsedTaxes = parseTaxes(hotel, reservationObj, summaryBreakdownMode);
    } else {
      const hotelAvail = store.getIn([
        'avail',
        hotelId,
        store.getIn(['hotels', hotelId, 'params', store.getIn(['availQuery', 'mono', 'query_params'])]),
        'response'
      ]);
      const reservationRequest = store.getIn(['customer', 'reservation_request']);
      const serviceAvailResponse = store.getIn([
        'availServices',
        hotelId,
        store.getIn(['hotels', hotelId, 'params', 'service_query_params']),
        'response'
      ]);
      if (hotelAvail && reservationRequest) {
        parsedTaxes = parseTaxesPreview(
          hotel,
          hotelAvail,
          serviceAvailResponse ? serviceAvailResponse.get('services', false) : false,
          reservationRequest,
          summaryBreakdownMode
        );
      }
    }

    if (parsedTaxes) {
      const { taxes, additionalFees } = applyMandatoryFeeSplit(parsedTaxes, true);
      const nonIncludedTaxes = round(sumTaxAmounts(taxes.nonIncluded));
      const totalsBothModes = getReservationTotalsBothModes(store);

      displayedTotalPrice = getDisplayedTotalPrice({
        summaryPriceBreakdown: true,
        nonIncludedTaxes,
        priceBase: totalsBothModes.getIn(['without_taxes', 'total_price']) + additionalFees,
        totalPriceWithTaxes: totalsBothModes.getIn(['with_taxes', 'total_price']),
        totalPrice: null
      });
    }
  }

  return {
    stepCode,
    hotel,
    currentStep: store.getIn(['customer', 'step', 'current_step']),
    reservationTotals:
      reservationBlocks && is(List, reservationBlocks) && reservationBlocks.size > 0 && getReservationTotals(store),
    displayedTotalPrice,
    summaryPriceBreakdown,
    params: params || undefined,
    urlParams: urlParams || undefined,
    city: city || Map(),
    country: country || Map(),
    stayLength: store.getIn(['customer', 'params', 'params', 'stay_length']),
    engineIsVisible: store.getIn(['customer', 'header', 'engine']),
    searchOptionsIsVisible: store.getIn(['customer', 'header', 'search_options']),
    giftCodeDiscount: giftCodeDiscount,
    enableAge,
    langInfo: store.getIn(['customer', 'lang_info']),
    appConfig,
    countryCode: store.getIn(['customer', 'country', 'code']),
  };
};

const mapDispatchToProps = (dispatch, ownProps, state) => {
  return {
    showEngine: (show) => {
      dispatch(actions.customer.header.show('engine', show));
    }
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, ['params']),
  connect(mapStateToProps, mapDispatchToProps),
  PropertyManager([
    'stepCode',
    'currentStep',
    'params',
    'enableAge',
    'hotel',
    'city',
    'country',
    'reservationTotals',
    'urlParams',
    'showEngine',
    'engineIsVisible',
    'searchOptionsIsVisible',
    'giftCodeDiscount',
    'displayedTotalPrice',
    'summaryPriceBreakdown',
    'appConfig',
    'langInfo',
    'stayLength',
    'dateFormat',
    'countryCode'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(Header);
